import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MessagingService {
    public successObservable = new Subject<string>();
    public warningObservable = new Subject<string>();
    public errorObservable = new Subject<string>();

    public showSuccessMsg(message: string) {
        // console.log(`showSuccessMsg: ${message}`);
        this.successObservable.next(message);
    }

    public showWarningMsg(message: string) {
        // console.log(`showWarningMsg: ${message}`);
        this.warningObservable.next(message);
    }

    public showErrorMsg(message: string) {
        // console.log(`showErrorMsg: ${message}`);
        this.errorObservable.next(message);
    }
}
